import CryptoJS from 'crypto-js'
import md5 from 'crypto-js/md5'
import Cookies from 'js-cookie'
import { SYSTEM_INFO, USER_TOKEN } from './constant'
import axios from 'axios'
import qs from 'qs'


/**
 * @description: MD5加密
 * @param {type}
 * @return:
 */
export function encryptMD5 (str) {
  str = md5(str).toString()
  return str
}
/* -----------------------------加密解密------------------------------------ Start */
const ivs = 'pH!@#*()'; const keys = 'Ph201912'
// AES加密
export function encryptAES (data) { // 加密
  var key = CryptoJS.enc.Utf8.parse(keys)
  var iv = CryptoJS.enc.Utf8.parse(ivs)
  var encrypted = CryptoJS.AES.encrypt(data, key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
  return encrypted.toString()
}
// AES解密
export function decryptAES (data) { // 解密
  var key = CryptoJS.enc.Utf8.parse(keys)
  var iv = CryptoJS.enc.Utf8.parse(ivs)
  var decrypted = CryptoJS.AES.decrypt(data, key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
/* -----------------------------加密解密------------------------------------ End */
/* -----------------------------localStorage------------------------------------ Start */
export function setLocalStorage (key, content) {
  if (!key) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(key, encryptAES(content))
}

export function getLocalStorage (key, f) {
  if (!key) return
  let content = window.localStorage.getItem(key)
  if (!content) return
  if (f) {
    return JSON.parse(decryptAES(content))
  }
  return decryptAES(content)
}

export function removeLocalStorage (key) {
  if (!key) return
  window.localStorage.removeItem(key)
}
/* -----------------------------localStorage------------------------------------ End */
/*------------------------------Cookie-------------------------------------------start*/
//获取cookie、
export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return (arr[2]);
    else
      return null;
  }
  
  //设置cookie,增加到vue实例方便全局调用
  export function setCookie (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
  };
  
  //删除cookie
  export function delCookie (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
     document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
/*------------------------------Cookie-------------------------------------------End*/
export function getUUID () {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4'
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23] = '-'

  return s.join('')
}

export function getAppUserToken() {
  return Cookies.get(USER_TOKEN)
}

export function getSystem () {
  var info = getLocalStorage(SYSTEM_INFO, true)
  if (!info) {
    // 获取移动端设备信息
    info = {
      model: '', // 手机型号
      pixelRatio: window.devicePixelRatio, // 像素比
      windowWidth: window.screen.width, // 窗口宽
      windowHeight: window.screen.height, // 窗口高
      system: '', // 操作系统
      version: '' // 版本
    }
    var MobileDetect = require('mobile-detect')
    var md = new MobileDetect(navigator.userAgent)
    info.system = md.os() //  获取系统
    if (info.system === 'iOS') { // ios系统的处理
      info.version = md.version('iPhone')
      // 判断iphone x 和 iphone xr
      if (info.windowHeight === 812 || info.windowHeight === 896) {
        info.model = 'iphoneX'
      } else if (info.windowHeight === 736 && info.windowWidth === 414) {
        info.model = 'iphone678P'
      } else if (info.windowHeight === 667 && info.windowWidth === 375) {
        info.model = 'iphone678'
      } else if (info.windowHeight === 568 && info.windowWidth === 320) {
        info.model = 'iPhone5'
      } else {
        info.model = 'iPhone4'
      }
    } else {
      info.version = md.version('Android')
      info.model = md.mobile()
    }
    setLocalStorage(SYSTEM_INFO, info)
  }
  return info
}

/**
 * 客户端检测
 */
export const BrowserInfo = function () {
  let ua = navigator.userAgent.toLowerCase()
  var json = {
    isAndroid: ua.indexOf('android') > -1 || ua.indexOf('Adr') > -1,
    isIOS: !!ua.match(/\(i[^;]+;( U;)? cpu.+mac os x/),
    isWeixin: ua.match(/MicroMessenger/i) == 'micromessenger',
    isChrome: window.navigator.userAgent.indexOf('Chrome') !== -1,
    isQQ: ua.match(/QQ/i) == 'qq'
  }

  return json
}

// 判断是否是ios9以上
var isIOS9 = function () {
  // 获取固件版本
  var getOsv = function () {
    var reg = /OS ((\d+_?){2,3})\s/
    if (navigator.userAgent.match(/iPad/i) || navigator.platform.match(/iPad/i) || navigator.userAgent.match(/iP(hone|od)/i) || navigator.platform.match(/iP(hone|od)/i)) {
      var osv = reg.exec(navigator.userAgent)
      if (osv.length > 0) {
        return osv[0].replace('OS', '').replace('os', '').replace(/\s+/g, '').replace(/_/g, '.')
      }
    }
    return ''
  }
  var osv = getOsv()
  var osvArr = osv.split('.')
  // 初始化显示ios9引导
  if (osvArr && osvArr.length > 0) {
    if (parseInt(osvArr[0]) >= 9) {
      return true
    }
  }
  return false
}

export function openAppDetail (openUrl) {
  var browser = BrowserInfo()
  function checkOpen () {
    var _clickTime = +(new Date())
    // 启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
    var _count = 0; var intHandle
    intHandle = setInterval(function () {
      _count++
      var elsTime = +(new Date()) - _clickTime
      if (_count >= 100 || elsTime > 3000) {
        window.location.href = downloadApp(browser)
        clearInterval(intHandle)
      }
    }, 20)
  }
}

// 打开APP
export function openApp (openUrl) {
  var browser = BrowserInfo()
  // 检查app是否打开
  function checkOpen () {
    var _clickTime = +(new Date())
    // 启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
    var _count = 0; var intHandle
    intHandle = setInterval(function () {
      _count++
      var elsTime = +(new Date()) - _clickTime
      if (_count >= 100 || elsTime > 3000) {
        window.location.href = downloadApp(browser)
        clearInterval(intHandle)
      }
    }, 20)
  }

  if (browser.isWeixin) {
    if (browser.isAndroid) { // 通过应用宝打开
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.gian.punkhoo&android_schema=' + openUrl
    } else {
      window.location.href = 'https://itunes.apple.com/cn/app/pang-hu-she-chi-pin/id1021204443?mt=8'
    }
  } else {
    // 在iframe 中打开APP
    var ifr = document.createElement('iframe')
    ifr.src = openUrl
    ifr.style.display = 'none'

    if (browser.isIOS) {
      if (isIOS9()) {
        window.location.href = openUrl
      }
    } else if (browser.isAndroid) {
      if (browser.isChrome) {
        window.location.href = openUrl
      }
    }

    checkOpen()

    document.body.appendChild(ifr)
    setTimeout(function () {
      document.body.removeChild(ifr)
    }, 2000)
  }
}

export function downloadApp (browser) {
  if (browser.isIOS) {
    return 'https://itunes.apple.com/cn/app/pang-hu-she-chi-pin/id1021204443?mt=8'
  } else if (browser.isAndroid) {
    return 'https://a.app.qq.com/o/simple.jsp?pkgname=com.gian.punkhoo'
  } else { // 浏览器
    return 'https://a.app.qq.com/o/simple.jsp?pkgname=com.gian.punkhoo'
  }
}

export function getWechatNumber () {
  var api_url = "https://apiv2-app.ponhu.cn/index/getWechatNumber"
  return new Promise((resolve, reject) => {
    axios.get(api_url)
      .then(res => {
        resolve(res.data.list)
      })
      .catch(err => {
        // Toast(err)
        reject(err)
      })
  })
}